// extracted by mini-css-extract-plugin
export default {"activityLog":"style_activityLog__PgUjc","step":"style_step__gfWnG","tankStep":"style_tankStep__30RCF","arrow":"style_arrow__yrQZ6"};